import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Transition as _Transition } from "vue";
const _hoisted_1 = {
  class: "account"
};
const _hoisted_2 = ["aria-label", "aria-expanded", "disabled"];
const _hoisted_3 = {
  class: "account__row-label"
};
const _hoisted_4 = {
  class: "account__row-meta"
};
const _hoisted_5 = {
  class: "account__row-label"
};
const _hoisted_6 = {
  class: "account__row-meta"
};
const _hoisted_7 = {
  class: "account__row-label"
};
const _hoisted_8 = {
  class: "account__row-label"
};
const _hoisted_9 = {
  key: 2,
  class: "account__error",
  role: "alert"
};
const _hoisted_10 = ["disabled", "aria-busy"];
const _hoisted_11 = {
  key: 0,
  class: "account__spinner",
  "aria-hidden": "true"
};
const _hoisted_12 = {
  class: "account__row-label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PhUser = _resolveComponent("PhUser");
  const _component_PhGlobe = _resolveComponent("PhGlobe");
  const _component_PhGear = _resolveComponent("PhGear");
  const _component_router_link = _resolveComponent("router-link");
  const _component_PhSignOut = _resolveComponent("PhSignOut");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
    type: "button",
    class: "account__trigger",
    "aria-label": _ctx.$t('appShell.account'),
    "aria-expanded": $data.open,
    disabled: $data.loggingOut,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggle && $options.toggle(...args)),
    ref: "triggerRef"
  }, [_createVNode(_component_PhUser, {
    class: "account__icon",
    size: 18,
    weight: "regular",
    "aria-hidden": "true"
  })], 8, _hoisted_2), _createVNode(_Transition, {
    name: "account-menu"
  }, {
    default: _withCtx(() => [$data.open ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "account__sheet",
      role: "menu",
      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
    }, [_createElementVNode("button", {
      type: "button",
      class: "account__row",
      role: "menuitem",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.handleTheme && $options.handleTheme(...args))
    }, [(_openBlock(), _createBlock(_resolveDynamicComponent($options.themeIcon), {
      class: "account__row-icon",
      size: 18,
      weight: "regular",
      "aria-hidden": "true"
    })), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('appShell.darkMode')), 1), _createElementVNode("span", _hoisted_4, _toDisplayString($options.themeLabel), 1)]), _createElementVNode("button", {
      type: "button",
      class: "account__row",
      role: "menuitem",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.handleLanguage && $options.handleLanguage(...args))
    }, [_createVNode(_component_PhGlobe, {
      class: "account__row-icon",
      size: 18,
      weight: "regular",
      "aria-hidden": "true"
    }), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('appShell.language')), 1), _createElementVNode("span", _hoisted_6, _toDisplayString($options.languageLabel), 1)]), _cache[6] || (_cache[6] = _createElementVNode("hr", {
      class: "account__divider"
    }, null, -1)), $props.isAdmin ? (_openBlock(), _createBlock(_component_router_link, {
      key: 0,
      to: "/systemConfig",
      class: "account__row",
      role: "menuitem",
      onClick: $options.close
    }, {
      default: _withCtx(() => [_createVNode(_component_PhGear, {
        class: "account__row-icon",
        size: 18,
        weight: "regular",
        "aria-hidden": "true"
      }), _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('appShell.settings')), 1)]),
      _: 1
    }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_router_link, {
      key: 1,
      to: "/adminLogin",
      class: "account__row",
      role: "menuitem",
      onClick: $options.close
    }, {
      default: _withCtx(() => [_createVNode(_component_PhGear, {
        class: "account__row-icon",
        size: 18,
        weight: "regular",
        "aria-hidden": "true"
      }), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('appShell.adminConsole')), 1)]),
      _: 1
    }, 8, ["onClick"])), _cache[7] || (_cache[7] = _createElementVNode("hr", {
      class: "account__divider"
    }, null, -1)), $data.logoutError ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString($data.logoutError), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
      type: "button",
      class: "account__row account__row--danger",
      role: "menuitem",
      disabled: $data.loggingOut,
      "aria-busy": $data.loggingOut,
      onClick: _cache[3] || (_cache[3] = (...args) => $options.handleLogout && $options.handleLogout(...args))
    }, [$data.loggingOut ? (_openBlock(), _createElementBlock("span", _hoisted_11)) : (_openBlock(), _createBlock(_component_PhSignOut, {
      key: 1,
      class: "account__row-icon",
      size: 18,
      weight: "regular",
      "aria-hidden": "true"
    })), _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t($data.loggingOut ? 'appShell.loggingOut' : 'appShell.logout')), 1)], 8, _hoisted_10)])) : _createCommentVNode("", true)]),
    _: 1
  }), $data.open ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "account__scrim",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.close && $options.close(...args))
  })) : _createCommentVNode("", true)]);
}